import { legacyUpsellContentKeys, Offer, Upsell, UpsellContent } from '../entities';
import { getCalculatedUpsell } from './getCalculatedUpsell';

// TODO: Remove once every flow keys upsell content by offer key
type LegacyUpsellsContent<T> = Record<string, T | undefined>;

// TODO: Remove together with LegacyUpsellsContent — camelCase content carries no authored order,
// so display order stays what each step used to hardcode
const legacyKeysOrder = ['ULTRA_PACK', 'NUMEROLOGY_ANALYSIS', 'TAROT_READING', 'PALMISTRY_GUIDE'];

export const mapContentToUpsells = <T extends UpsellContent>(
  content: LegacyUpsellsContent<T> | undefined,
  offers: Record<string, Offer>,
): Array<Upsell & T> => {
  if (!content) {
    return [];
  }

  const blocks = Object.entries(content).flatMap(([key, block]) => {
    if (!block) {
      return [];
    }

    return [
      {
        offerKey: legacyUpsellContentKeys[key] ?? key,
        isLegacy: key in legacyUpsellContentKeys,
        block,
      },
    ];
  });

  const legacyBlocks = legacyKeysOrder.flatMap((offerKey) => {
    const legacyBlock = blocks.find((item) => item.isLegacy && item.offerKey === offerKey);

    return legacyBlock ? [legacyBlock] : [];
  });

  const authoredBlocks = blocks.filter(({ isLegacy }) => !isLegacy);

  const upsells = [...legacyBlocks, ...authoredBlocks].flatMap(({ offerKey, block }) => {
    const offer = offers[offerKey];

    return offer
      ? [{ ...getCalculatedUpsell(block, offer), offerKey, offerId: offer.offerId }]
      : [];
  });

  return upsells;
};
